
import {Vue, Component, Prop, Emit} from 'vue-property-decorator';
import moment from 'moment';

import {userApi} from '@/api';
import formHelper from '../../../js/account/account.helper';

Vue.prototype.moment = moment;
@Component({
    components: {}
})
export default class New_Teacher extends Vue {
    @Prop({default: {}}) editTeacher?: any;
    @Prop({default: ''}) teacherType?: string;
    // 清空表单并关闭新建/编辑教师模态框
    @Emit('closeModal') private closeModal() {}
    // 刷新教师列表
    // @Emit('refreshTeacherList') private refreshTeacherList() {}
    // 显示授课管理模态框
    @Emit('showTeacherAuthorize') private showTeacherAuthorize() {}
    //===================================data区域begin
    formTeacher: any = formHelper.newTeacherForm;
    formRulesTeacher: any = formHelper.formRulesTeacher;
    // 新建教师表单学校有效期
    schoolValidityStart: string = '';
    schoolValidityEnd: string = '';
    // 新建或编辑教师有效期选择组件是否显示
    isSchoolValidity: boolean = true;
    // 编辑教师是否过期
    isOverdueTeacher: boolean = false;
    // 新建教师保存的数据（用于保存并进入授课设置后的授课管理）
    newTeacherData: any = {};
    //===================================data区域end
    //===================================computed区域begin
    isNewTeacher() {
        return this.teacherType === '新增';
    }
    //===================================computed区域end
    //===================================methods区域begin
    // 清空表单数据
    refreshForm() {
        this.isOverdueTeacher = false;
        this.formTeacher.nickname = '';
        this.formTeacher.sex = undefined;
        this.formTeacher.username = '';
        this.formTeacher.password = '';
        this.formTeacher.mobile = '';
        this.formTeacher.isSchoolAdmin = false;
        this.formTeacher.validStartTime = '';
        this.formTeacher.expireTime = '';
        this.formTeacher._id = '';
    }
    handleCancel() {
        this.refreshForm();
        this.$emit('closeModal');
    }
    handleSave(flag: any) {
        // console.log(this.formTeacher);
        let isValid = false;
        let me = this;
        (me.$refs.teacherForm as any).validate((valid: any) => {
            if (!valid) {
                return;
            }
            isValid = true;
            if (isValid) {
                let form: any = JSON.parse(JSON.stringify(me.formTeacher));
                if (form.sex == 'null') {
                    form.sex = null;
                }
                if (form.password == '') {
                    delete form.password;
                }
                userApi.saveRecord({
                    context: me,
                    data: form,
                    success(data: any, parameters: any) {
                        // console.log(data);
                        me.newTeacherData = data.data;
                        me.$message.success('恭喜你，操作成功！');
                        if (flag == 'authorize') {
                            me.$emit('showTeacherAuthorize', me.newTeacherData);
                        }
                        me.handleCancel();
                        me.$emit('refreshTeacherList');
                    },
                    error(error: any, message: string, parameters: any) {
                        me.$message.error(message);
                    }
                });
            }
        });
    }
    // 选择性别
    chooseTeacherSex(value: any) {
        this.formTeacher.sex = value;
    }
    // 使用默认密码
    useDefaultPassword() {
        this.formTeacher.password = '123456';
    }
    // 学校管理员权限
    changeRole(checked: boolean) {
        this.formTeacher.isSchoolAdmin = checked;
    }
    // 账号有效期
    changeTeacherRadio(e: any) {
        // console.log(e);
        if (e.target.value == 'custom') {
            this.isSchoolValidity = false;
            this.formTeacher.isDefaultExpire = false;
            this.formTeacher.validStartTime = null;
            this.formTeacher.expireTime = null;
        } else {
            this.isSchoolValidity = true;
            this.formTeacher.isDefaultExpire = true;
            // 学校管理员有效期同学校有效期
            this.formTeacher.validStartTime = this.schoolValidityStart;
            this.formTeacher.expireTime = this.schoolValidityEnd;
        }
    }
    disabledDate(current: any) {
        return (current && current < moment(this.schoolValidityStart)) || current > moment(this.schoolValidityEnd).add(1, 'day');
    }
    // 教师账号有效期
    changeTeacherDate(dates: any) {
        // console.log(dates);
        if (dates[0]) {
            this.formTeacher.validStartTime = dates[0].format('YYYY/MM/DD');
            if (moment(dates[1].format('YYYY/MM/DD')) > moment(this.schoolValidityEnd)) {
                this.formTeacher.expireTime = this.schoolValidityEnd;
                dates[1] = moment(this.schoolValidityEnd);
            } else {
                this.formTeacher.expireTime = dates[1].format('YYYY/MM/DD');
            }
        } else {
            this.formTeacher.validStartTime = null;
            this.formTeacher.expireTime = null;
        }
        // 手动校验学校管理员有效期
        (this.$refs.teacherForm as any).validateField('validStartTime', (valid: any) => {
            if (!!valid === false) {
                console.log('error...........');
                return;
            }
        });
    }
    //===================================methods区域end
    created() {
        // console.log(this);
        // console.log(this.editTeacher);
        let schoolInfo: any = JSON.parse(window.localStorage.getItem('schoolInfo') as string);
        if (schoolInfo) {
            // console.log(schoolInfo);
            this.formTeacher.schoolId = schoolInfo._id;
            this.schoolValidityStart = schoolInfo.validStartTime;
            this.schoolValidityEnd = schoolInfo.expireTime;
        }
        this.isSchoolValidity = true;
        this.formTeacher.validStartTime = this.schoolValidityStart;
        this.formTeacher.expireTime = this.schoolValidityEnd;
    }
    mounted() {
        if (!this.isNewTeacher()) {
            let editForm: any = this.editTeacher;
            this.formTeacher.nickname = editForm.nickname;
            if (editForm.sex == 0 || editForm.sex) {
                this.formTeacher.sex = editForm.sex.toString();
            } else {
                this.formTeacher.sex = 'null';
            }
            this.formTeacher.username = editForm.username;
            // this.formTeacher.password = '';
            this.formTeacher.mobile = editForm.mobile;
            this.formTeacher.isSchoolAdmin = editForm.roles.includes('schoolAdmin');
            if (!editForm.isDefaultExpire) {
                this.isSchoolValidity = false;
                this.formTeacher.isDefaultExpire = false;
                this.formTeacher.validStartTime = editForm.validStartTime;
                this.formTeacher.expireTime = editForm.expireTime;
                this.isOverdueTeacher = moment(editForm.expireTime.replace(/\//g, '-')).diff(moment(), 'day') < 0;
            }
            this.formTeacher._id = editForm._id;
        }
    }
}
